import { render, staticRenderFns } from "./servicion_bienes.vue?vue&type=template&id=0b5a60cc&scoped=true"
import script from "./servicion_bienes.vue?vue&type=script&lang=js"
export * from "./servicion_bienes.vue?vue&type=script&lang=js"
import style0 from "./servicion_bienes.vue?vue&type=style&index=0&id=0b5a60cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5a60cc",
  null
  
)

export default component.exports